import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { useAuth } from "../lib/auth";
import { Trophy, Crown, Medal, ArrowLeft, Flame } from "lucide-react";

export default function Leaderboard() {
    const { user } = useAuth();
    const [list, setList] = useState([]);

    useEffect(() => {
        client.get("/leaderboard").then((r) => setList(r.data));
    }, []);

    return (
        <div className="px-5 pt-8 pb-8">
            <Link to="/app" className="inline-flex items-center text-zinc-500 hover:text-white">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Home</span>
            </Link>
            <div className="mt-4">
                <span className="label-cap text-xs text-neon-orange">Leaderboard</span>
                <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Who's Ahead</h1>
                <p className="text-zinc-400 text-sm mt-1">Top 50 warriors. Real XP only.</p>
            </div>

            {/* Top 3 podium */}
            <div className="mt-6 grid grid-cols-3 gap-2 items-end">
                {[1, 0, 2].map((idx, pos) => {
                    const u = list[idx];
                    if (!u) return <div key={pos} />;
                    const heights = ["h-24", "h-32", "h-20"];
                    const colors = ["#A3A3A3", "#39FF14", "#FF3B30"];
                    const icons = [Medal, Crown, Medal];
                    const Icon = icons[pos];
                    return (
                        <div key={u.id} className="flex flex-col items-center">
                            <div
                                className="w-12 h-12 rounded-full flex items-center justify-center"
                                style={{ background: `${colors[pos]}20`, border: `2px solid ${colors[pos]}` }}
                            >
                                <Icon size={20} style={{ color: colors[pos] }} />
                            </div>
                            <div className="font-display font-bold uppercase text-xs text-center mt-2 truncate max-w-full px-1">
                                {u.name}
                            </div>
                            <div
                                className={`${heights[pos]} w-full surface-2 mt-2 flex flex-col items-center justify-end pb-2`}
                                style={{ borderTop: `2px solid ${colors[pos]}` }}
                            >
                                <div className="font-display font-black text-2xl" style={{ color: colors[pos] }}>
                                    {u.xp}
                                </div>
                                <div className="text-[9px] uppercase text-zinc-500 tracking-widest">XP</div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="mt-6 space-y-2">
                {list.map((u, i) => (
                    <div
                        key={u.id}
                        data-testid={`leaderboard-row-${i + 1}`}
                        className={`surface-1 p-3 flex items-center gap-3 ${
                            u.id === user?.id ? "border-neon-green" : ""
                        }`}
                    >
                        <div className="w-8 text-center font-display font-black text-lg">
                            {i < 3 ? (
                                <Trophy
                                    size={18}
                                    className={
                                        i === 0 ? "text-neon-green" : i === 1 ? "text-zinc-300" : "text-neon-orange"
                                    }
                                />
                            ) : (
                                <span className="text-zinc-500">#{i + 1}</span>
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="font-display font-bold uppercase text-sm leading-none truncate">
                                {u.name} {u.id === user?.id && <span className="text-neon-green text-[10px]">(you)</span>}
                            </div>
                            <div className="flex items-center gap-2 mt-1 text-xs text-zinc-500">
                                <span>Lv {u.current_level}</span>
                                <span className="flex items-center gap-1 text-neon-orange">
                                    <Flame size={10} /> {u.streak || 0}
                                </span>
                            </div>
                        </div>
                        <div className="text-right">
                            <div className="font-display font-black text-xl text-neon-green">{u.xp}</div>
                            <div className="label-cap text-[9px] text-zinc-500">XP</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
